import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  PARENT_CATEGORY_LIST,
  PARENT_CATEGORY_LIST_SUCCESS,
  PARENT_CATEGORY_LIST_FAILURE,
  SUB_CATEGORY_LIST,
  SUB_CATEGORY_LIST_SUCCESS,
  SUB_CATEGORY_LIST_FAILURE,
  CHILD_CATEGORY_LIST,
  CHILD_CATEGORY_LIST_SUCCESS,
  CHILD_CATEGORY_LIST_FAILURE,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILURE,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  VIEW_CATEGORY,
  VIEW_CATEGORY_SUCCESS,
  VIEW_CATEGORY_FAILURE,
  UPDATE_STATUS_CATEGORY,
  UPDATE_STATUS_CATEGORY_SUCCESS,
  UPDATE_STATUS_CATEGORY_FAILURE,
  GET_PARENT_SUB_CATEGORY_PRODUCT,
  GET_PARENT_SUB_CATEGORY_PRODUCT_SUCCESS,
  GET_PARENT_SUB_CATEGORY_PRODUCT_FAILURE,
  PARENT_CATEGORY_BY_CHILD,
  PARENT_CATEGORY_BY_CHILD_SUCCESS,
  PARENT_CATEGORY_BY_CHILD_FAILURE
} from "../../Actions/types";

const initialState = {
  getParentCategoryLoader: false,
  getParentCategoryError: false,
  getParentCategoryData: null,
  getSubCategoryLoader: false,
  getSubCategoryError: false,
  getSubCategoryData: null,
  createCategoryLoader: false,
  createCategoryError: false,
  createCategoryData: null,
  getCategoryListData: null,
  getCategoryListLoader: false,
  getCategoryListError: false,
  updateCategoryData: null,
  updateCategoryLoader: false,
  updateCategoryError: false,
  viewCategoryData: null,
  viewCategoryLoader: false,
  viewCategoryError: false,
  updateStatusCategoryLoader: false,
  updateStatusCategoryData: null,
  updateStatusCategoryError: false,
  getChildCategoryListData: null,
  getChildCategoryListLoader: false,
  getChildCategoryListError: false,
  renewablelessiondata: null,
  renewablelessionloader: false,
  renewablelessionerror: false,
  getsubcategoryproduct: null,
  getsubcategoryproductloader: false,
  getsubcategoryproducterror: false,
  getParentCategoryByChild: null,
  getParentCategoryByChildLoader: false,
  getParentCategoryByChildError: false
};
function categoryManagementReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_CATEGORY:
      return { ...state, createCategoryLoader: true };
    case CREATE_CATEGORY_SUCCESS:
      return {
        ...state,
        createCategoryData: action?.payload,
        createCategoryLoader: false,
      };
    case CREATE_CATEGORY_FAILURE:
      return {
        ...state,
        createCategoryLoader: false,
        createCategoryError: true,
      };

    case PARENT_CATEGORY_LIST:
      return { ...state, getParentCategoryLoader: true };
    case PARENT_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        getParentCategoryData: action?.payload,
        getParentCategoryLoader: false,
      };
    case PARENT_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        getParentCategoryLoader: false,
        getParentCategoryError: true,
      };

    case SUB_CATEGORY_LIST:
      return { ...state, getSubCategoryLoader: true };
    case SUB_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        getSubCategoryData: action?.payload,
        getSubCategoryLoader: false,
      };
    case SUB_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        getSubCategoryLoader: false,
        getSubCategoryError: true,
      };


      case PARENT_CATEGORY_BY_CHILD:
        return { ...state, getParentCategoryByChildLoader: true };
      case PARENT_CATEGORY_BY_CHILD_SUCCESS:
        return {
          ...state,
          getParentCategoryByChild: action?.payload,
          getParentCategoryByChildLoader: false,
        };
      case PARENT_CATEGORY_BY_CHILD_FAILURE:
        return {
          ...state,
          getParentCategoryByChildLoader: false,
          getParentCategoryByChildError: true,
        };



    case GET_CATEGORY_LIST:
      return { ...state, getCategoryListLoader: true };
    case GET_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        getCategoryListData: action?.payload,
        getCategoryListLoader: false,
      };
    case GET_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        getCategoryListLoader: false,
        getCategoryListError: true,
      };

    case CHILD_CATEGORY_LIST:
      return { ...state, getChildCategoryListLoader: true };
    case CHILD_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        getChildCategoryListData: action?.payload,
        getChildCategoryListLoader: false,
      };
    case CHILD_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        getCategoryListLoader: false,
        getChildCategoryListError: true,
      };

    case UPDATE_CATEGORY:
      return { ...state, updateCategoryLoader: true };
    case UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        updateCategoryData: action?.payload,
        updateCategoryLoader: false,
      };
    case UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        updateCategoryLoader: false,
        updateCategoryError: true,
      };

    case UPDATE_STATUS_CATEGORY:
      return { ...state, updateStatusCategoryLoader: true };
    case UPDATE_STATUS_CATEGORY_SUCCESS:
      return {
        ...state,
        updateStatusCategoryData: action?.payload,
        updateStatusCategoryLoader: false,
      };
    case UPDATE_STATUS_CATEGORY_FAILURE:
      return {
        ...state,
        updateStatusCategoryLoader: false,
        updateStatusCategoryError: true,
      };

    case VIEW_CATEGORY:
      return { ...state, viewCategoryLoader: true };
    case VIEW_CATEGORY_SUCCESS:
      return {
        ...state,
        viewCategoryData: action?.payload,
        viewCategoryLoader: false,
      };
    case VIEW_CATEGORY_FAILURE:
      return {
        ...state,
        viewCategoryLoader: false,
        viewCategoryError: true,
      };

    case GET_PARENT_SUB_CATEGORY_PRODUCT:
      return {
        ...state,
        getsubcategoryproductloader: true,
      };

    case GET_PARENT_SUB_CATEGORY_PRODUCT_SUCCESS:
      return {
        ...state,

        getsubcategoryproductloader: false,
        getsubcategoryproduct: action?.payload,
      };

    case GET_PARENT_SUB_CATEGORY_PRODUCT_FAILURE:
      return {
        ...state,
        getsubcategoryproductloader: false,
        getsubcategoryproducterror: true,
      };

    default:
      return state;
  }
}

export default categoryManagementReducer;
